'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var tslib = require('tslib');
var jsxRuntime = require('react/jsx-runtime');
var cx = require('classnames');
var GridItem = require('../GridItem/GridItem.js');

function _interopDefault (e) { return e && e.__esModule ? e : { default: e }; }

var cx__default = /*#__PURE__*/_interopDefault(cx);

var GridCard = function (_a) {
    var _b = _a.childClassName, childClassName = _b === void 0 ? '' : _b, _c = _a.firstChildClassName, firstChildClassName = _c === void 0 ? '' : _c, _d = _a.lastChildClassName, lastChildClassName = _d === void 0 ? '' : _d, children = _a.children;
    return (jsxRuntime.jsx(GridItem.default, tslib.__assign({ childClassName: cx__default.default('border-end border-start px-3', childClassName), firstChildClassName: cx__default.default('rounded-top border-top pt-3', firstChildClassName), lastChildClassName: cx__default.default('rounded-bottom border-bottom pb-3', lastChildClassName) }, { children: children })));
};
var GridCard$1 = GridCard;

exports.default = GridCard$1;
//# sourceMappingURL=GridCard.js.map
